"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFormatPattern = exports.supportedMethods = exports.defaultConfiguration = void 0;
var threshold_1 = require("./models/threshold");
/**
 * Configuration defaults for Vista Diagnostics Log class
 */
exports.defaultConfiguration = {
    console: {
        thresholdLevel: threshold_1.ThresholdLevel.INFO,
        messageColor: '#444444',
        messagePrefix: 'Vista',
        messagePrefixColor: '#0090ad' // Vista teal
    }
};
/**
 * Supported logging methods
 */
exports.supportedMethods = ['trace', 'debug', 'info', 'warn', 'error'];
/**
 * Pattern string used to format date
 */
exports.dateFormatPattern = 'yyyy/MM/dd HH:mm:ss';
//# sourceMappingURL=log.constants.js.map